// This file is auto-generated by @hey-api/openapi-ts
import { client } from './client.gen';
export class AppService {
    /**
     * Get hello message
     *
     * Returns a simple welcome message for the API Gateway
     */
    static getHello(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            url: '/',
            ...options
        });
    }
}
export class TfAgwApplicationService {
    /**
     * Get all applications
     *
     * Returns a list of all applications
     */
    static getAll(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            url: '/application',
            ...options
        });
    }
}
export class TfAgwUserService {
    /**
     * Get all users
     *
     * Returns a list of all users
     */
    static getAllUsers(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/users',
            ...options
        });
    }
    /**
     * Get users by permissions
     *
     * Returns UUIDs of users who have specific permissions
     */
    static getUsersUuidsByPermissions(options) {
        return (options.client ?? client).get({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/users-by-permissions',
            ...options
        });
    }
    /**
     * Check user permission
     *
     * Checks if a specific user has a specific permission in a company
     */
    static checkUserHasPermission(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/{company}/users/{uuid}/has-permission',
            ...options
        });
    }
    /**
     * Update user organization profile
     *
     * Updates the organization profile of a user (e.g. blocking/unblocking)
     */
    static updateUserOrganizationProfile(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/users-organization-profile/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class TfAgwPersonalSettingsService {
    /**
     * Get personal settings
     *
     * Returns personal settings for the current user
     */
    static getPersonalSettings(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/personal-settings',
            ...options
        });
    }
    /**
     * Update personal settings
     *
     * Updates personal settings for the current user
     */
    static updatePersonalSettings(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/personal-settings',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class TfAgwAuthService {
    /**
     * User login
     *
     * Authenticates user with Firebase ID token and returns profile
     */
    static login(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            url: '/{tenant}/auth/login',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Clear custom token cookie
     *
     * Clears the custom token cookie on logout
     */
    static clearCustomToken(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            url: '/{tenant}/auth/custom-token',
            ...options
        });
    }
    /**
     * Get custom token
     *
     * Retrieves custom token from cookie
     */
    static getCustomToken(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            url: '/{tenant}/auth/custom-token',
            ...options
        });
    }
    /**
     * Create custom token
     *
     * Creates a custom Firebase token and sets it as a cookie
     */
    static createCustomToken(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            url: '/{tenant}/auth/custom-token',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Impersonate user
     *
     * Generates a Firebase custom token for the target user and sets it as a cookie. Requires AGW_APP / IMPERSONATE permission.
     */
    static impersonate(options) {
        return (options.client ?? client).post({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/auth/impersonate',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Stop impersonation
     *
     * Verifies the current session is impersonated, generates a custom token for the original admin and sets it as a cookie.
     */
    static stopImpersonation(options) {
        return (options.client ?? client).post({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/auth/impersonate/stop',
            ...options
        });
    }
    /**
     * Get user profile
     *
     * Returns profile of the currently authenticated user
     */
    static userProfile(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/auth/user-profile',
            ...options
        });
    }
    /**
     * Get Firebase config
     *
     * Returns Firebase authentication configurations for all organizations
     */
    static firebaseConfig(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            url: '/auth/firebase-config',
            ...options
        });
    }
}
export class TfAgwOrganizationService {
    /**
     * Get all organizations
     *
     * Returns a list of all organizations
     */
    static getAllOrganizations(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/organizations',
            ...options
        });
    }
    /**
     * Update organization
     *
     * Updates an existing organization
     */
    static updateOrganization(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/organizations/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class TfAgwPositionService {
    /**
     * Get all positions
     *
     * Returns a list of all positions
     */
    static getAllPositions(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/positions',
            ...options
        });
    }
    /**
     * Create position
     *
     * Creates a new position
     */
    static createPosition(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/positions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get all work categories
     *
     * Returns a list of all work categories
     */
    static getAllWorkCategories(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/positions/work-categories',
            ...options
        });
    }
    /**
     * Get position permissions
     *
     * Return all permission with actions actually configured for given position
     */
    static getAllPositionPermission(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/positions/{uuid}/permissions',
            ...options
        });
    }
    /**
     * Update position permissions
     *
     * Updates permissions for a specific position
     */
    static updatePositionPermission(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/positions/{positionUuid}/permissions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update position
     *
     * Updates an existing position
     */
    static updatePosition(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/positions/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Publish update messages
     *
     * Publishes messages for created or updated positions
     */
    static createUpdateMessages(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/positions/create-updated-messages',
            ...options
        });
    }
}
export class TfAgwDepartmentService {
    /**
     * Get all departments
     *
     * Returns a list of all departments for a given organization
     */
    static getAllDepartment(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/departments',
            ...options
        });
    }
    /**
     * Create department
     *
     * Creates a new department
     */
    static createDepartment(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/departments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update department
     *
     * Updates an existing department
     */
    static updateDepartment(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/departments/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Publish update messages
     *
     * Publishes messages for created or updated departments
     */
    static createUpdateMessages(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/departments/create-updated-messages',
            ...options
        });
    }
}
export class TfAgwPermissionService {
    /**
     * Get all permissions
     *
     * Return all permission with actions. This can be used for setting up to position
     */
    static getAllPermissions(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/permissions',
            ...options
        });
    }
}
export class TfAgwHealthService {
    /**
     * Health check
     *
     * Performs a health check of the application and database
     */
    static healthCheck(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            url: '/health',
            ...options
        });
    }
}
export class TfAgwMetabaseService {
    /**
     * Get Metabase embed token
     *
     * Returns a signed JWT token for embedding a Metabase dashboard. The token is valid for 10 minutes.
     */
    static getEmbedToken(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/metabase/dashboards/{reportId}/embed-token',
            ...options
        });
    }
    /**
     * List Metabase reports
     *
     * Returns the list of Metabase reports the current user is allowed to see.
     */
    static listReports(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/metabase/reports',
            ...options
        });
    }
    /**
     * Get Metabase client config
     *
     * Returns non-private Metabase configuration (e.g. instance URL) so that clients do not need to know the ENV directly.
     */
    static getConfig(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/metabase/config',
            ...options
        });
    }
}
export class TfAgwKioskPairingService {
    /**
     * Start a kiosk pairing session
     *
     * TV calls this on the pairing page. Returns a 6-digit code that the admin enters in the claim form. The TV polls /pairing/poll until status === "paired".
     */
    static start(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/kiosk/pairing/start',
            ...options
        });
    }
    /**
     * Poll pairing status
     *
     * TV polls this endpoint with the sessionId returned from /start. The `key` field is delivered exactly once — subsequent polls return status === "expired".
     */
    static poll(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/kiosk/pairing/poll',
            ...options
        });
    }
    /**
     * Pair (or re-pair) a kiosk by binding a key to an existing SA
     *
     * Admin enters the 6-digit code shown on the TV plus the UUID of an existing ServiceAccount (created beforehand with its positions in the admin CRUD page). The server generates a fresh key on that SA, (re)activates it, and the TV picks it up on its next poll. The SA's name, positions and reload interval are preserved. Used both for the first pairing and for re-pairing after a lost key.
     */
    static rotateKey(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/kiosk/pairing/rotate-key',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class TfAgwKioskServiceAccountsService {
    /**
     * List kiosk service accounts
     *
     * Returns all ServiceAccounts in the tenant (each with its attached positions + the permission actions those positions grant).
     */
    static list(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/kiosk/service-accounts',
            ...options
        });
    }
    /**
     * Create a service account
     *
     * Creates an unpaired ServiceAccount with the given name and (optional) positions. Pair it with a kiosk afterwards via /kiosk/pairing/rotate-key to bind a key.
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/kiosk/service-accounts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a service account
     *
     * Hard-deletes the SA and its position join rows. The positions themselves are left untouched.
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/kiosk/service-accounts/{uuid}',
            ...options
        });
    }
    /**
     * Update a service account
     *
     * Rename, toggle isActive (revocation), change the auto-reload interval, or replace the attached positions (which define its permissions).
     */
    static update(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/kiosk/service-accounts/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class TfAgwKioskSelfConfigService {
    /**
     * Get the calling kiosk service-account self-config
     *
     * Called by the TV with its service-account key. Returns the per-kiosk settings (reload interval, …) so the layout can apply them without re-pairing.
     */
    static getSelfConfig(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/kiosk/self-config',
            ...options
        });
    }
}
export class TestSupportService {
    /**
     * Load fixtures
     *
     * Loads test fixtures into the database
     */
    static loadFixtures(options) {
        return (options?.client ?? client).post({ url: '/test-support/load-fixtures', ...options });
    }
    /**
     * Set permissions
     *
     * Overrides permissions for a position for testing purposes
     */
    static setPermissions(options) {
        return (options.client ?? client).post({
            url: '/test-support/set-permissions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
